<div #toggleContainer
     class="toggle-container" [class.activated]="state"
     (click)="onToggle()">
    <div class="toggle-knob" [class.activated]="state">
        <i #toggleKnobIcon class="toggle-knob-icon"></i>
    </div>
</div>
